export const trackEvent = async (eventName: any, eventMetadata: any) => {
    try {        
        window.Intercom && window.Intercom('trackEvent', eventName, eventMetadata);
    } catch (error) {
        console.log(error);
    }
};
